export default "__VITE_ASSET__4c8lf2hl__"